// src/components/PaginationComponent.js
import React from 'react';
import { Pagination } from 'antd';

const PaginationComponent = ({ currentPage, totalPages, onPageChange, pageSize = 20 }) => {
    return (
        <Pagination
            current={currentPage}
            total={totalPages * pageSize}
            pageSize={pageSize}
            onChange={onPageChange}
            showSizeChanger={false}
            style={{ textAlign: 'center', margin: '16px 0' }}
        />
    );
};

export default PaginationComponent;
